import styled, { keyframes, css } from 'styled-components'

// ── paleta (coerente com as demais telas do sistema) ──────────────
const TEAL = 'var(--teal)'
const TEAL_TEXT = 'var(--teal-text, var(--teal))';
const TEAL_LIGHT = 'var(--teal-light)'
const TEAL_SOFT = 'var(--teal-soft)'
const GRAY_BG = 'var(--bg)'
const GRAY_LINE = 'var(--line)'
const GRAY_TEXT = 'var(--text-muted)'
const GREEN = 'var(--green)'
const GREEN_SOFT = 'var(--green-soft)'
const GREEN_LINE = '#cdeac8'
const RED = 'var(--red, #dc2626)'
const RED_SOFT = 'var(--red-soft)'
const RED_LINE = 'var(--red)'
const PURPLE = '#6a3fb0'
const PURPLE_SOFT = '#efe9f8'
//const PURPLE_LINE = '#dccdf0'
const DARK = '#2c3338'
const DARK_SOFT = '#eceef0'
const AMBER = 'var(--amber, #d97706)'

const bp = {
    desktop: '1024px',
    tablet: '768px',
    mobile: '540px',
    small: '380px'
}

const expand = keyframes`
    from { opacity: 0; transform: translateY(-6px); }
    to   { opacity: 1; transform: translateY(0); }
`
const shimmer = keyframes`
    0%   { background-position: -400px 0; }
    100% { background-position: 400px 0; }
`

export const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    background: ${GRAY_BG};
    padding: 16px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;

    @media (max-width: ${bp.tablet}) { padding: 12px; }
    @media (max-width: ${bp.mobile}) { padding: 8px; }
`

export const ContainerDivs = styled.div`
    width: 100%;
    max-width: 860px;
    display: flex;
    flex-direction: column;
    gap: 14px;

    @media (max-width: ${bp.mobile}) { gap: 10px; }
`

export const ContainerStudent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 14px;

    @media (max-width: ${bp.mobile}) { gap: 10px; }
`

/* ── Header ─────────────────────────────────────────────────────── */

export const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 18px 20px;
    background: ${TEAL};
    color: #fff;
    border-radius: 14px;
    box-shadow: 0 6px 18px rgba(0, 62, 79, 0.18);

    @media (max-width: ${bp.mobile}) { padding: 14px 16px; border-radius: 12px; }
`

export const BackButton = styled.button`
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    border: none;
    background: rgba(255, 255, 255, 0.14);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background .15s ease;

    &:hover { background: rgba(255, 255, 255, 0.26); }
    &:focus-visible { outline: 2px solid #fff; outline-offset: 2px; }
`

export const HeaderInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    flex: 1;
`

export const Title = styled.h1`
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0.2px;

    @media (max-width: ${bp.mobile}) { font-size: 17px; }
`

export const Subtitle = styled.span`
    font-size: 12px;
    font-weight: 600;
    opacity: 0.9;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    font-variant-numeric: tabular-nums;
`

/* ── Cartão de seleção de data ─────────────────────────────────── */

export const DateCard = styled.div`
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 14px;
    padding: 28px 22px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;

    h3 { margin: 0; color: ${TEAL_TEXT}; font-size: 18px; }
`

export const DateField = styled.input`
    width: 100%;
    max-width: 280px;
    border: 1px solid ${GRAY_LINE};
    border-radius: 10px;
    padding: 12px 14px;
    font-size: 16px;
    color: ${TEAL_TEXT};
    outline: none;
    transition: border-color .15s ease, box-shadow .15s ease;

    &:focus {
        border-color: ${TEAL_LIGHT};
        box-shadow: 0 0 0 3px rgba(10, 90, 115, 0.10);
    }
`

/* ── Barra de status (data + ações) ────────────────────────────── */

export const Toolbar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 12px;
    padding: 12px 14px;
`

export const DateBadge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 700;
    color: ${TEAL_TEXT};
    font-variant-numeric: tabular-nums;
`

export const ProgressWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1;
    min-width: 160px;
`

export const ProgressTrack = styled.div`
    width: 100%;
    height: 8px;
    border-radius: 999px;
    background: ${TEAL_SOFT};
    overflow: hidden;
`

export const ProgressFill = styled.div`
    height: 100%;
    width: ${({ $pct }) => `${$pct}%`};
    border-radius: 999px;
    background: linear-gradient(90deg, ${GREEN} 0%, ${TEAL_LIGHT} 100%);
    transition: width .35s ease;
`

export const ProgressText = styled.span`
    font-size: 12px;
    font-weight: 600;
    color: ${GRAY_TEXT};
    font-variant-numeric: tabular-nums;
`

/* ── Botões ─────────────────────────────────────────────────────── */

const btnBase = css`
    border: none;
    border-radius: 8px;
    padding: 10px 18px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    min-height: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: filter .12s ease, transform .12s ease, background .12s ease;

    &:active { transform: translateY(1px); }
    &:disabled { opacity: .55; pointer-events: none; }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }

    @media (max-width: ${bp.mobile}) { min-height: 46px; }
`

export const Btt02 = styled.button`
    ${btnBase}
    background: ${TEAL};
    color: #fff;
    &:hover { filter: brightness(1.12); }

    @media (max-width: 375px) { font-size: 12px; padding: 8px 12px; }
`

export const GhostButton = styled.button`
    ${btnBase}
    background: var(--surface);
    color: ${TEAL_TEXT};
    border: 1px solid ${GRAY_LINE};
    &:hover { background: ${GRAY_BG}; }
`

export const FinalizeButton = styled.button`
    ${btnBase}
    background: ${GREEN};
    color: #fff;
    width: 100%;
    font-size: 15px;
    &:hover { filter: brightness(1.1); }
`

export const DangerButton = styled.button`
    ${btnBase}
    background: ${RED_SOFT};
    color: ${RED};
    border: 1px solid ${RED_LINE};
    width: 100%;
    &:hover { filter: brightness(.97); }
`

export const DivButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
`

/* ── "Marcar todos" ─────────────────────────────────────────────── */

export const MarkAllBar = styled.label`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    background: ${GREEN_SOFT};
    border: 1px solid ${GREEN_LINE};
    border-radius: 12px;
    padding: 12px 16px;
    font-weight: 700;
    font-size: 14px;
    color: ${GREEN};
    cursor: pointer;

    input { width: 22px; height: 22px; cursor: pointer; accent-color: ${GREEN}; }
`

/* ── Lista de alunos ────────────────────────────────────────────── */

export const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
`

export const SectionLabel = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 700;
    color: ${GRAY_TEXT};
    text-transform: uppercase;
    letter-spacing: 0.3px;
    padding: 6px 2px;

    &:before, &:after {
        content: '';
        height: 1px;
        background: ${GRAY_LINE};
        flex: 1;
    }
`

// cartão de aluno (lista para marcar)
export const Emp = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    border-radius: 12px;
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    animation: ${expand} .16s ease;

    @media (max-width: ${bp.mobile}) { padding: 13px; }
`

export const StudentName = styled.span`
    font-size: 15px;
    font-weight: 700;
    color: ${TEAL_TEXT};
    overflow-wrap: anywhere;

    @media (max-width: ${bp.small}) { font-size: 14px; }
`

/* compat com import antigo <Span> */
export const Span = StudentName

// grupo de opções de status (segmented control)
export const StatusGroup = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;

    @media (max-width: ${bp.mobile}) { grid-template-columns: repeat(2, 1fr); }
`

// cor de identidade de cada status (usada na borda/texto mesmo quando inativo)
const statusColor = ($variant) =>
    $variant === 'P' ? GREEN
        : $variant === 'F' ? RED
            : $variant === 'FJ' ? PURPLE
                : DARK
const statusSoft = ($variant) =>
    $variant === 'P' ? GREEN_SOFT
        : $variant === 'F' ? RED_SOFT
            : $variant === 'FJ' ? PURPLE_SOFT
                : DARK_SOFT

// cada opção (presença/falta/justificada/não adicionar)
// Inativo: já mostra a cor de identidade (borda + texto coloridos, fundo claro)
// Ativo: preenchido na cor cheia, texto branco, com leve elevação
export const StatusOption = styled.button`
    border: 2px solid ${({ $variant }) => statusColor($variant)};
    background: ${({ $active, $variant }) =>
        $active ? statusColor($variant) : statusSoft($variant)};
    color: ${({ $active, $variant }) => ($active ? 'var(--surface)' : statusColor($variant))};
    border-radius: 12px;
    padding: 12px 8px;
    font-size: 14px;
    font-weight: 800;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    min-height: 64px;
    justify-content: center;
    box-shadow: ${({ $active, $variant }) =>
        $active ? `0 4px 12px ${statusColor($variant)}55` : '0 1px 2px rgba(0,0,0,0.06)'};
    transform: ${({ $active }) => ($active ? 'translateY(-1px)' : 'none')};
    transition: border-color .12s ease, background .12s ease, color .12s ease,
        transform .12s ease, box-shadow .12s ease;

    &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px ${({ $variant }) => `${statusColor($variant)}40`};
    }
    &:disabled { opacity: .35; pointer-events: none; }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }

    /* ícone/símbolo grande no topo */
    & > span:first-child {
        font-size: 20px;
        line-height: 1;
    }

    small { font-size: 11.5px; font-weight: 700; line-height: 1.1; text-align: center; }

    @media (max-width: ${bp.small}) {
        min-height: 60px;
        & > span:first-child { font-size: 18px; }
        small { font-size: 11px; }
    }
`

/* ── Chamadas finalizadas ──────────────────────────────────────── */

export const ListChecked = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    margin-top: 4px;
`

export const CheckedItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 12px;
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

    @media (max-width: ${bp.mobile}) { padding: 12px 13px; }
`

export const SpanChecked = styled.span`
    font-size: 15px;
    font-weight: 600;
    color: ${TEAL_TEXT};
    overflow-wrap: anywhere;

    @media (max-width: ${bp.small}) { font-size: 13px; }
`

export const CheckedActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
`

// pílula de status (P / F / FJ / -)
export const StatusPill = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 36px;
    height: 32px;
    padding: 0 10px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 800;
    color: #fff;
    background: ${({ $status }) =>
        $status === 'P' ? GREEN
            : $status === 'FJ' ? PURPLE
                : $status === '-' ? DARK
                    : RED};
`

export const EditIconButton = styled.button`
    ${btnBase}
    background: ${TEAL_SOFT};
    color: ${TEAL_TEXT};
    padding: 8px 14px;
    min-height: 32px;
    font-size: 13px;
    &:hover { background: var(--teal-soft); }
`

/* ── Painel de edição / confirmação ────────────────────────────── */

export const EditContainer = styled.div`
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 14px;
    padding: 22px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
    animation: ${expand} .2s ease;

    h3 { margin: 0; text-align: center; color: ${TEAL_TEXT}; font-size: 17px; }

    select {
        width: 100%;
        max-width: 360px;
        padding: 11px 12px;
        font-size: 15px;
        border: 1px solid ${GRAY_LINE};
        border-radius: 8px;
        color: ${TEAL_TEXT};
        outline: none;
        &:focus { border-color: ${TEAL_LIGHT}; box-shadow: 0 0 0 3px rgba(10,90,115,.1); }
    }

    @media (max-width: ${bp.mobile}) { padding: 18px 16px; }
`

export const ExcludeToggle = styled.label`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    font-weight: 600;
    color: ${GRAY_TEXT};
    cursor: pointer;
    input { width: 20px; height: 20px; cursor: pointer; accent-color: ${DARK}; }
`

export const BoxButtonEdit = styled.div`
    display: flex;
    gap: 12px;
    width: 100%;
    max-width: 360px;

    & > button { flex: 1; }
`

/* ── Aviso (dia não letivo / bimestre fechado) ─────────────────── */

export const Notice = styled.div`
    background: var(--surface);
    border: 1px solid ${({ $tone }) => ($tone === 'danger' ? RED_LINE : '#f3e2c0')};
    border-left: 4px solid ${({ $tone }) => ($tone === 'danger' ? RED : AMBER)};
    border-radius: 12px;
    padding: 22px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    text-align: center;

    h2, h3 { margin: 0; color: ${({ $tone }) => ($tone === 'danger' ? RED : AMBER)}; }
    p { margin: 0; color: ${GRAY_TEXT}; font-size: 14px; line-height: 1.5; }
`

/* ── Skeleton ───────────────────────────────────────────────────── */

export const SkeletonItem = styled.div`
    width: 100%;
    height: 92px;
    border-radius: 12px;
    background: linear-gradient(90deg, var(--skel-a) 0%, var(--skel-b) 50%, var(--skel-a) 100%);
    background-size: 800px 100%;
    animation: ${shimmer} 1.3s linear infinite;
`

/* ── Voltar (rodapé) ────────────────────────────────────────────── */

export const ToGoBack = styled.div`
    display: flex;
    gap: 6px;
    justify-content: center;
    align-items: center;
    padding: 14px 8px;
    cursor: pointer;
    user-select: none;
    color: ${GRAY_TEXT};
    font-size: 14px;
    min-height: 44px;
    &:hover { color: ${TEAL_TEXT}; }
`

export const SignMessageButtonText = styled.span``
export const SignMessageButtonTextBold = styled.span`
    font-weight: 700;
    color: ${TEAL_TEXT};
    margin-left: 4px;
`

/* ── compat (imports antigos não usados no novo layout) ────────── */
export const DataSelected = styled.div`width: 100%;`
export const DivInfoDate = DateCard
export const BoxButtonStatus = styled.div`display: flex; gap: 16px;`
export const EmpEdit = Emp
export const DivInfo = EditContainer
export const SelectorContainer = styled.div`margin-bottom: 20px;`
export const AttendanceList = List
export const AttendanceItem = CheckedItem
export const AttendanceButton = Btt02
export const BoxButton = styled.div`display: flex; flex-direction: column; gap: 12px; width: 100%;`